import { Component, OnDestroy, OnInit } from '@angular/core';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-breadcrumb-settings',
	styleUrls: ['./breadcrumb-settings.component.css'],
	templateUrl: './breadcrumb-settings.component.html'
})
export class BreadcrumbSettingsComponent implements OnInit, OnDestroy {
	public showCalendar = false;
	private toggleSubscription;

	constructor() {
		this.toggleSubscription = EmitterService.get('TOGGLE_CALENDAR').subscribe((resp: any) => {
			this.showCalendar = resp;
		});
	}

	ngOnInit(): void {}

	ngOnDestroy(): void {
		this.toggleSubscription.unsubscribe();
	}
}
